module.exports = __webpack_public_path__ + "img/logo.f3d276da.png";